import React from "react";
import Table from "../CommonTable";

const ProcessCard = ({ higher }) => {
  const rows = [
    {
      photo: "table-car.png",
      goodsName: "Suzuki Swift",
      otherDetails: ["2019", "100,526 km"],
      goodsPrice: {
        amount: "275,000 Yen",
        status: "Reserved Price Met",
      },
      dueInPlace: "SAGAMIHARA SERVICE CENTER",
      auctionInfo: {
        number: "No.1109671",
        type: "Auction",
        timeRemaining: "0 day 13:51 until the end",
      },
    },
  ];
  return (
    <div className="process-card">
      <Table rows={rows} />
      <BidInfo higher={higher} />
      <Details />
    </div>
  );
};

const BidInfo = ({ higher }) => {
  return (
    <div className="bid-info" style={{ alignItems: "start" }}>
      <div className="prices">
        <div>Current Price：100,000 Yen</div>
        <div>Total Price：100,000 Yen</div>
        <div>Bid Price：</div>
        <div>Total Price：</div>
      </div>
      <div className="others confirm">
        <Counter />

        <button className="bid-btn round" style={{ height: 80 }}>
          <img src="hammer.png" alt="hammer.png"/>
          Confirm Bid
        </button>
        <div className="total-price">Total Price：190,298 Yen</div>
      </div>
    </div>
  );
};

const Counter = () => {
  const [value, setValue] = React.useState(100000);

  const handleIncrement = () => {
    setValue((prevValue) => prevValue + 1);
  };

  const handleDecrement = () => {
    setValue((prevValue) => prevValue - 1);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div
        className="textual"
        style={{ transform: "translateX(-40%)", marginBottom: 20 }}
      >
        <h2>Bid Amount</h2>
        <span>Bid Unit Price (1000 Yen)</span>
      </div>
      <div className="counter">
        <div className="input-box">
          <input
            type="number"
            className="hide-arrows"
            value={value}
            onChange={(e) => setValue(parseInt(e.target.value))}
          />
          Yen
        </div>
        <div className="count-btns">
          <button onClick={handleIncrement}>
            <i className="fa fa-angle-up"></i>
          </button>
          <button onClick={handleDecrement}>
            <i className="fa fa-angle-down"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export const Details = () => {
  return (
    <div className="confirm-details">
      <h1>Details of Bidding Conditions</h1>
      <div className="confirm-tables">
        <div className="table1">
          <div className="left">
            <h3>Trade Term</h3>
            <h3>Delivery address</h3>
            <h3>Delivery address for documents</h3>
            <h3>Estimated Arrival Date</h3>
          </div>
        </div>
        <div className="table1">
          <div className="left">
            <h3>Bid Price</h3>
            <h3>Inland Delivery</h3>
            <h3>
              Service Center <br />
              Operation Charge
            </h3>
            <h3>Sales Commission</h3>
            <h3>Tax</h3>
            <h3>Recycling Fee</h3>
            <h3 className="last">Total Price</h3>
          </div>
          <div className="right">
            <h3>70,000Yen</h3>
            <h3>70,000Yen</h3>
            <h3>70,000Yen</h3>
            <h3>70,000Yen</h3>
            <h3>70,000Yen</h3>
            <h3>70,000Yen</h3>
            <h3 className="last">70,000Yen</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessCard;
